import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useGlobalContext } from "context/global";
import RescheduleSubscription from "components/account/subscription/reschedule";
import Modal from "components/modal";
import useToggle from "hooks/useToggle";
import { ModalLayout } from "components/subscription-flow";
import { TOGGLE_RESCHEDULE_MODAL } from "utils/action-types";
import { trackRescheduleSubscription } from "services/analytics";

const ReschedulingFlow = () => {
	const { translation } = useGlobalContext();
	const { subscriptionId, reschedule, nextBillingDate } = useSelector((state) => state.account.subscription);
	const [isSurveyShown, toggleSurvey] = useToggle();
	const [chargePrompt, toggleChargePrompt] = useToggle();
	const dispatch = useDispatch();

	const surveyTranslation = translation.subscription.reschedule_survey;

	useEffect(() => {
		// If the reschedule modal is closed and the survey is shown, we need to toggle the survey visibility
		if (!reschedule.isModalOpen && isSurveyShown) toggleSurvey();
	}, [reschedule]);

	if (!nextBillingDate) return null;

	const handleModalClose = () => {
		if (isSurveyShown) {
			trackRescheduleSubscription(subscriptionId, "No reason selected", nextBillingDate);
		}

		dispatch({ type: TOGGLE_RESCHEDULE_MODAL, skipSurvey: false });
	};

	return (
		<Modal
			isOpen={reschedule.isModalOpen}
			close={handleModalClose}
			title={isSurveyShown || chargePrompt ? "" : translation.subscription?.change_delivery_date}
			className="text-center max-w-md pb-10"
			headerStyle="!px-10"
		>
			<ModalLayout
				title={isSurveyShown ? surveyTranslation?.title : ""}
				description={isSurveyShown ? surveyTranslation?.description : ""}
				bodyClassName="w-full"
			>
				<div className="flex flex-col justify-center items-center !size-full !px-3 md:px-5">
					<RescheduleSubscription
						showSurvey={isSurveyShown}
						toggleSurvey={toggleSurvey}
						setChargePrompt={toggleChargePrompt}
						chargePrompt={chargePrompt}
					/>
				</div>
			</ModalLayout>
		</Modal>
	);
};

export default ReschedulingFlow;